import { create } from "zustand";
import {
  ItemYoutobe,
  TblItemCategoryAttrModel,
  TblItemCategoryCommand,
  TblItemCommand,
  TblItemImageCommand,
  TblItemSeoCommand,
  TblItemTechnicalCommonCommand,
  TblItemYoutubeCommand,
  tblTagItemModels,
} from "../model/ProductList";
import { TblAttributeModel } from "../model/TblAttributeModelFix";

type ProductCreateState = {
  dataItemBase?: TblItemCommand;
  dataItemCategory: TblItemCategoryCommand[];
  dataItemSeo: TblItemSeoCommand[];
  dataItemTechnical: TblItemTechnicalCommonCommand[];
  dataItemCategoryAttrModel: TblItemCategoryAttrModel[];
  dataItemYoutube: any;
  dataItemImage: any;
  dataItemTagIds: tblTagItemModels[];
  setDataItemBase: (data: any) => void;
  setDataItemCategory: (data: any) => void;
  setDataItemSeo: (data: TblItemSeoCommand[]) => void;
  setDataItemTechnical: (data: TblItemTechnicalCommonCommand[]) => void;
  // setDataItemCategoryAttrModel: (data: TblAttributeModel[]) => void;
  setDataItemCategoryAttrModel: (data:TblItemCategoryAttrModel[]) => void;
  setDataItemYoutube: (data: any) => void;
  setDataItemImage: (data: TblItemImageCommand[]) => void;
  setDataItemTagIds: (data: tblTagItemModels[]) => void;
  resetState: () => void;
};

export const useProductCreateStore = create<ProductCreateState>((set) => ({
  dataItemBase: undefined,
  dataItemCategory: [],
  dataItemSeo: [],
  dataItemTechnical: [],
  dataItemCategoryAttrModel: [],
  dataItemYoutube: [],
  dataItemImage: [],
  dataItemTagIds: [],
  setDataItemBase: (data: any) => set({ dataItemBase: data }),
  setDataItemCategory: (data: any) => set({ dataItemCategory: data }),
  setDataItemSeo: (data: any) => set({ dataItemSeo: data }),
  setDataItemTechnical: (data: any) => set({ dataItemTechnical: data }),
  setDataItemCategoryAttrModel: (data: any) =>
    set({ dataItemCategoryAttrModel: data }),
  setDataItemYoutube: (data: any) => set({ dataItemYoutube: data }),
  setDataItemImage: (data: any) => set({ dataItemImage: data }),
  setDataItemTagIds: (data: any) => set({ dataItemTagIds: data }),
  resetState: () =>
    set({
      dataItemBase: undefined,
      dataItemCategory: [],
      dataItemSeo: [],
      dataItemTechnical: [],
      dataItemCategoryAttrModel: [],
      dataItemYoutube: [],
      dataItemImage: [],
      dataItemTagIds: [],
    }),
}));
